// What the page's error boundary is keyed on — and so what remounts the
// page. Keyed on the whole path, every URL change rebuilt the screen from
// nothing: picking a driver in Driver pay (/payroll/people/:id) reloaded
// the list, the panel and the editor to change one pane.
//
// Most screens still want that: their inputs read a value once (MUI
// defaultValue), so moving from one candidate to the next without a
// remount would leave the first person's details in the boxes. The screens
// below select WITHIN themselves by URL and are written to follow the
// parameter, so they are keyed on the screen and only what changed updates.
const SELECT_IN_PLACE = ['/payroll/people', '/files/folder'];

export function boundaryKey(pathname: string): string {
  const path = pathname.replace(/\/+$/, '') || '/';
  // The top of Files is the same screen as its folders.
  if (path === '/files') return '/files/folder';
  return SELECT_IN_PLACE.find((p) => path === p || path.startsWith(`${p}/`)) || path;
}
